import i18n from '../../common/i18n';
import moment, { Moment } from 'moment/moment';
import { betbookLastParam$ } from './subs';
import { capitalize } from 'lodash';
import { dispatch, useReframe } from 'nike-re-framejs';
import { setBetbookLastParam } from './handlers';
import { useCallback, useMemo } from 'react';

export const useBetbookLastParam = () => {
    const { subscribe } = useReframe();
    const lastParam = subscribe(betbookLastParam$);

    const lastQueryParams: Record<string, any> = useMemo(() => {
        try {
            if (!lastParam) {
                return;
            }
            return JSON.parse(lastParam);
        } catch (e) {
            console.error(e);
            return;
        }
    }, [lastParam]);

    const setLastQueryParams = useCallback((params: Record<string, any> = {}) => {
        dispatch(setBetbookLastParam(JSON.stringify(params)));
    }, []);

    return [lastQueryParams, setLastQueryParams] as const;
};

/**
 * Get formatted date using custom momentjs calendar format
 * see https://momentjs.com/docs/#/displaying/calendar-time/
 * @returns {string}   - formatted date
 * @param referenceDay - moment date to format
 */
export const getCalendarFormattedDate = (referenceDay: Moment): string => {
    return moment(referenceDay).calendar({
        sameDay: `[${capitalize(referenceDay.fromNow())}]`,
        lastDay: `[${i18n('nui.calendar.yesterday')}]`,
        lastWeek: 'DD.MM.YYYY',
        sameElse: 'DD.MM.YYYY'
    });
};
